import { z } from "zod";

// Schema for editing company details
export const editCompanyDetailsSchema = z.object({
  companyName: z.string().min(1, "Company name is required"),
  companyEmail: z.string().email("Invalid email address").nullable().optional(),
  websiteUrl: z.string().nullable().optional().or(z.literal("")),
  salesforceId: z.string().nullable().optional(),
  intacctId: z.string().nullable().optional(),
  marketingEnabled: z.boolean(),
  hasEaglesAccess: z.boolean(),
  hasLATAAccess: z.boolean(),
});

// Schema for software selection
export const companySoftwareSchema = z.object({
  fieldServiceSoftwareId: z.number().nullable().optional(),
});

// Schema for trades selection
export const companyTradesSchema = z.object({
  tradeIds: z.array(z.number()),
});

// Combined schema for the entire form
export const editCompanySchema = z.object({
  // Company details
  companyName: z.string().min(1, "Company name is required"),
  companyEmail: z.string().email("Invalid email address").nullable().optional(),
  websiteUrl: z.string().nullable().optional().or(z.literal("")),
  salesforceId: z.string().nullable().optional(),
  intacctId: z.string().nullable().optional(),
  marketingEnabled: z.boolean(),
  hasEaglesAccess: z.boolean(),
  hasLATAAccess: z.boolean(),
  // Software
  fieldServiceSoftwareId: z.number().nullable().optional(),
  // Trades
  tradeIds: z.array(z.number()),
});

// Schema for creating company
export const createCompanySchema = z.object({
  companyName: z.string().min(1, "Company name is required"),
  companyEmail: z.string().email("Invalid email address").nullable().optional().or(z.literal("")),
  websiteUrl: z.string().nullable().optional().or(z.literal("")),
  salesforceId: z.string().nullable().optional().or(z.literal("")),
  intacctId: z.string().min(1, "Intacct ID is required"),
  marketingEnabled: z.boolean(),
  hasEaglesAccess: z.boolean(),
  hasLATAAccess: z.boolean(),
});

// Type inference
export type EditCompanyDetailsFormData = z.infer<typeof editCompanyDetailsSchema>;
export type CompanySoftwareFormData = z.infer<typeof companySoftwareSchema>;
export type CompanyTradesFormData = z.infer<typeof companyTradesSchema>;
export type EditCompanyFormData = z.infer<typeof editCompanySchema>;
export type CreateCompanyFormData = z.infer<typeof createCompanySchema>;